import { Navigate } from "react-router-dom";
import { getUser, isAuthed } from "./auth";

export default function PublicRoute({ children }: any) {
  if (!isAuthed()) return children;
  const user = getUser();
  if (user?.planSelectionCompleted === false) return <Navigate to="/onboarding/plan" replace />;
  return <Navigate to="/home" replace />;
}
